import { Grid, Stack, Text } from '@welbe/design-system';

type EmployeeSectionProps = {
	id: string;
	title: string;
	description: string;
	children: React.ReactNode;
};

export const EmployeeSection = ({
	id,
	title,
	description,
	children,
}: EmployeeSectionProps) => {
	return (
		<Grid gridTemplateColumns="1fr 2fr" w="100%" gap="1rem" my="3rem" id={id}>
			<Stack gap="0.5rem">
				<Text fontSize="lg" fontWeight="600" color="#0D0F12">
					{title}
				</Text>
				<Text fontSize="sm" fontWeight="400" color="fg.muted" lineHeight="20px">
					{description}
				</Text>
			</Stack>
			<Grid gridTemplateColumns="1fr 1fr" gap="3rem 1rem">
				{children}
			</Grid>
		</Grid>
	);
};
